import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import CompareText from '../CompareText'
import SummaryBox from '../SummaryBox'

interface Props {
  totalCurrentPeriodInCents?: number
  totalPreviousPeriodInCents?: number
  title: string
  subtitle?: string
  currency: string
}

const SummaryTotal = ({
  title,
  subtitle,
  totalCurrentPeriodInCents,
  totalPreviousPeriodInCents,
  currency,
}: Props) => {
  if (!totalCurrentPeriodInCents) {
    return (
      <SummaryBox title={title} subtitle={subtitle}>
        <Text.Normal color="grey1000" weight="medium" size="300" ellipsis>
          -
        </Text.Normal>
      </SummaryBox>
    )
  }

  return (
    <SummaryBox title={title} subtitle={subtitle}>
      <Box flexDirection="row">
        <Text.Normal color="grey1000" weight="medium" size="300" ellipsis>
          {i18n.formatNumber(totalCurrentPeriodInCents / 100, 'currency', currency)}
        </Text.Normal>
        {totalPreviousPeriodInCents && (
          <CompareText
            amount={Math.round(totalCurrentPeriodInCents - totalPreviousPeriodInCents)}
            currency={currency}
          />
        )}
      </Box>
    </SummaryBox>
  )
}

export default SummaryTotal
